<template>
	<form>
		<vue-perfect-scrollbar class="scroll-area--form" :settings="settingsForm">
			<vx-card card-border no-shadow>
				<h5 class="mb-1">{{ $t("Optimization.OptimizationPeriod") }}</h5>
				<form data-vv-scope="create-optimization">
					<div class="vx-row">
						<div class="vx-col w-full md:w-1/4 sm:w-1/1">
							<small class="date-label">{{ $t("CompanyCreate.InitDate") }}</small>
							<datepicker
								:language="$vs.rtl ? langHe : langEn"
								name="initDateOptimization"
								v-validate="'validatorInitDateOptimization'"
								v-model="dataOptimization.period.init_date"
							></datepicker>
							<span
								class="text-danger text-sm"
								v-show="errors.has('create-optimization.initDateOptimization')"
								>{{ $t("BreakForm.ErrorMessages.DateInitError") }}</span
							>
						</div>
						<div class="vx-col w-full md:w-1/4 sm:w-1/1">
							<small class="date-label">{{ $t("CompanyCreate.EndDate") }}</small>
							<datepicker
								:language="$vs.rtl ? langHe : langEn"
								v-validate="'validatorEndDateOptimization'"
								name="endDateOptimization"
								v-model="dataOptimization.period.end_date"
							></datepicker>
							<span
								class="text-danger text-sm"
								v-show="errors.has('create-optimization.endDateOptimization')"
								>{{ $t("BreakForm.ErrorMessages.DateInitError") }}</span
							>
						</div>
						<div class="vx-col w-full md:w-1/4 sm:w-1/1">
							<small class="date-label">{{ $t("Routing.Table.InitHour") }}</small>
							<flat-pickr
								:config="configdateTimePicker"
								class="w-full"
								v-model="dataOptimization.period.init_hour"
								v-validate="'validatorInitHourOptimization'"
								name="dataHourInitOptimization"
							/>
							<span
								class="text-danger text-sm"
								v-show="errors.has('create-optimization.dataHourInitOptimization')"
								>{{ $t("BreakForm.ErrorMessages.ValidInitHour") }}</span
							>
						</div>
						<div class="vx-col w-full md:w-1/4 sm:w-1/1">
							<small class="date-label">{{ $t("Routing.Table.EndHour") }}</small>
							<flat-pickr
								:config="configdateTimePicker"
								v-model="dataOptimization.period.end_hour"
								class="w-full"
								v-validate="'validatorEndHourOptimization'"
								name="dataHourEndOptimization"
							/>
							<span
								class="text-danger text-sm"
								v-show="errors.has('create-optimization.dataHourEndOptimization')"
								>{{ $t("BreakForm.ErrorMessages.ValidEndHour") }}</span
							>
						</div>
					</div>
				</form>
			</vx-card>
			<vx-card class="mt-1" card-border no-shadow>
				<h5 class="mb-1">{{ $t("GeneralInformation") }}</h5>
				<div class="vx-row">
					<div class="vx-col w-full md:w-1/2 sm:w-1/1">
						<small class="date-label">{{ $t("Name") }}</small>
						<vs-input
							v-model="dataOptimization.nameOptimization"
							class="w-full"
							name="name"
							v-validate="'required|max:128'"
							:placeholder="$t('Name')"
						/>
						<span class="text-danger text-sm" v-show="errors.has('name')">{{
							errors.first("name") !== undefined ? $t(`VValidateMessage.${errors.first("name")}`) : ""
						}}</span>
					</div>
					<div class="vx-col w-full md:w-1/2 sm:w-1/1">
						<small class="date-label">{{ $t("Group.OptimizationGroup") }}</small>
						<v-select v-model="dataOptimization.group" name="group" :options="groupOptions">
							<template v-slot:no-options="{search, searching}">
								<template v-if="searching">
									{{ $t("NoResultsFoundFor") + " " }}<em>{{ search }}</em>
								</template>
								<template v-else>
									{{ $t("NoResultsFound") }}
								</template>
							</template>
						</v-select>
					</div>
				</div>
				<div class="vx-row mt-2">
					<div
						class="vx-col"
						:class="
							selectedRoutingType === 'OPENROUTE' || selectedRoutingType === 'TOUR_PLANNING'
								? 'w-full md:w-1/2 sm:w-1/1'
								: 'w-full'
						"
					>
						<small class="date-label">{{ $t("RoutingType.SelectRoutingType") }}</small>
						<v-select
							v-model="dataOptimization.selectedRouter"
							name="routingTypes"
							:clearable="false"
							:options="routingTypes"
							:reduce="(option) => option.name"
							:get-option-label="getOptionLabel"
						>
							<template v-slot:no-options="{search, searching}">
								<template v-if="searching">
									{{ $t("NoResultsFoundFor") + " " }}<em>{{ search }}</em>
								</template>
								<template v-else>
									{{ $t("NoResultsFound") }}
								</template>
							</template>
							<template #option="option">
								<div class="option-with-icon">
									<img :src="option.icon" alt="" class="option-icon" />
									{{ option.name }}
								</div>
							</template>
						</v-select>
					</div>
					<div v-if="selectedRoutingType === 'OPENROUTE'" class="vx-col w-full md:w-1/2 sm:w-1/1">
						<small class="flex items-center date-label cursor-pointer">
							{{ $t("OpenrouteMesh") }}
							<i
								class="material-icons ml-1 text-primary"
								style="font-size: 16px"
								:title="$t('ViewMeshesAndTheirStatus')"
								@click.stop="showMeshes = true"
							>
								visibility
							</i>
						</small>
						<v-select
							v-model="dataOptimization.mesh"
							v-validate="'required'"
							name="meshes"
							:disabled="!dataOptimization.selectedRouter"
							:clearable="false"
							:options="meshOptions"
						>
							<template v-slot:no-options="{search, searching}">
								<template v-if="searching">
									{{ $t("NoResultsFoundFor") + " " }}<em>{{ search }}</em>
								</template>
								<template v-else>
									{{ $t("NoResultsFound") }}
								</template>
							</template>
							<template #option="{label, nameStatus}">
								<span class="flex items-center justify-between">
									{{ label }}
									<div class="flex items-center">
										<div class="h-3 w-3 rounded-full mr-1 bg-success"></div>
										<span style="font-size: 12px; font-weight: 600">{{ nameStatus }}</span>
									</div>
								</span>
							</template>
						</v-select>
						<span
							class="text-danger text-sm"
							v-show="selectedRoutingType === 'OPENROUTE' && !dataOptimization.hasOwnProperty('mesh')"
							>{{
								$t("Routing.AssignColumns.Text1") +
								" " +
								$t("OpenrouteMesh") +
								" " +
								$t("Routing.AssignColumns.Text2")
							}}</span
						>
					</div>
					<div v-if="selectedRoutingType === 'TOUR_PLANNING'" class="vx-col w-full md:w-1/2 sm:w-1/1 mt-6">
						<div class="flex items-center justify-start">
							<small class="date-label">
								{{ $t("RealTimeTrafficData") }}
								<i
									class="material-icons ml-1 text-primary"
									style="font-size: 16px"
									:title="$t('RealTimeTrafficDataText')"
								>
									info
								</i>
							</small>
							<vs-switch class="ml-2" color="success" v-model="dataOptimization.liveTraffic" />
						</div>
					</div>
				</div>
				<!-- START: GMPRO Objective Selection (Basic Only) -->
				<div v-if="selectedRoutingType === 'GMPRO'" class="vx-row mt-2">
					<div class="vx-col w-full sm:w-1/1">
						<small class="flex items-center date-label cursor-pointer">
							{{ $t("OptimizationObjectives") }}
							<i
								class="material-icons text-primary ml-1"
								style="font-size: 16px"
								:title="$t('ChooseOneOrMoreOfTheseObjectivesToCustomize')"
							>
								info
							</i>
						</small>
						<v-select
							name="objectives"
							multiple
							v-model="dataOptimization.objectiveListSelected"
							:placeholder="$t('DesignConfig.MultipleChoice')"
							:dir="$vs.rtl ? 'rtl' : 'ltr'"
							:clearable="true"
							:options="equivalentFieldsDefault"
							@input="setSelected"
						>
							<template v-slot:no-options="{search, searching}">
								<template v-if="searching">
									{{ $t("NoResultsFoundFor") + " " }}<em>{{ search }}</em>
								</template>
								<template v-else>
									{{ $t("NoResultsFound") }}
								</template>
							</template>
						</v-select>
					</div>
				</div>
				<!-- END: GMPRO Objective Selection -->
			</vx-card>
			<!-- Advanced Objectives Button for Tour Planning -->
			<div v-if="selectedRoutingType === 'TOUR_PLANNING'" class="vx-row mt-1">
				<div class="vx-col w-full">
					<!-- START: TOUR_PLANNING Objective Selection -->
					<vx-card card-border no-shadow>
						<h5 class="mb-1">{{ $t("OptimizationObjectives") }}</h5>
						<span class="text-secondary">{{ $t("SelectBasicOrAdvancedObjectives") }}</span>
						<div class="vx-row mt-4">
							<div class="vx-col w-full md:w-1/2">
								<div
									class="border rounded-lg cursor-pointer h-full"
									:class="{
										'border-primary': objectiveTypeSelection === 'basic',
										'bg-primary-light': objectiveTypeSelection === 'basic',
									}"
									@click="objectiveTypeSelection = 'basic'"
								>
									<vs-radio v-model="objectiveTypeSelection" vs-value="basic">
										<span class="flex items-center text-base cursor-pointer">
											{{ $t("BasicObjectives") }}
											<i
												class="material-icons ml-1"
												style="font-size: 16px"
												:title="$t('ChooseOneOrMoreOfTheseObjectivesToCustomize')"
											>
												info
											</i>
										</span>
									</vs-radio>
								</div>
							</div>
							<div class="vx-col w-full md:w-1/2">
								<div
									class="border rounded-lg cursor-pointer h-full"
									:class="{
										'border-primary': objectiveTypeSelection === 'advanced',
										'bg-primary-light': objectiveTypeSelection === 'advanced',
									}"
									@click="handleAdvancedSelection"
								>
									<vs-radio v-model="objectiveTypeSelection" vs-value="advanced">
										<span class="text-base">{{ $t("AdvancedObjectives.AdvancedObjectives") }}</span>
									</vs-radio>
								</div>
							</div>
						</div>
						<!-- Conditional Basic Objectives for TOUR_PLANNING -->
						<div v-if="objectiveTypeSelection === 'basic'" class="mt-4">
							<v-select
								name="objectives"
								multiple
								v-model="dataOptimization.objectiveListSelected"
								:placeholder="$t('DesignConfig.MultipleChoice')"
								:dir="$vs.rtl ? 'rtl' : 'ltr'"
								:clearable="true"
								:options="equivalentFieldsDefault"
								@input="setSelected"
							>
								<template v-slot:no-options="{search, searching}">
									<template v-if="searching">
										{{ $t("NoResultsFoundFor") + " " }}<em>{{ search }}</em>
									</template>
									<template v-else>
										{{ $t("NoResultsFound") }}
									</template>
								</template>
							</v-select>
						</div>
						<!-- Conditional Advanced Objectives for TOUR_PLANNING -->
						<div v-if="objectiveTypeSelection === 'advanced'" class="vx-col w-full mt-4">
							<div class="advanced-objectives-section">
								<div class="flex items-center justify-between">
									<div class="flex items-center font-bold">
										<h6 class="mb-0 mr-3">{{ $t("AdvancedObjectives.AdvancedObjectives") }}</h6>
										<vs-chip v-if="advancedObjectives.length > 0" color="success">
											{{ advancedObjectives.length }} {{ $t("AdvancedObjectives.Objectives") }}
										</vs-chip>
									</div>
									<vs-button
										color="success"
										icon="settings"
										size="small"
										class="font-bold"
										@click="showAdvancedObjectivesPopup = true"
									>
										{{ $t("AdvancedObjectives.ConfigureAdvancedObjectives") }}
									</vs-button>
								</div>
								<p class="text-secondary text-sm mt-2">
									{{ $t("AdvancedObjectives.AdvancedObjectivesDescription") }}
								</p>
							</div>
						</div>
					</vx-card>
					<!-- END: TOUR_PLANNING Objective Selection -->
				</div>
			</div>
			<vx-card class="mt-1" card-border no-shadow>
				<h5 class="mb-1">{{ $t("RoutingType.Transport") }}</h5>
				<span class="text-secondary">{{ $t("RoutingType.SelectMeansTransportText") }}</span>
				<div class="vx-row mt-1">
					<div class="vx-col w-full">
						<ul class="ul-area">
							<li class="mt-4">
								<div class="vx-row">
									<div class="vx-col w-full">
										<vs-radio v-model="dataOptimization.profileOption" vs-value="general">{{
											"Uno general para todos los  vehículos seleccionados"
										}}</vs-radio>
										<v-select
											v-model="dataOptimization.selectedVehicleProfile"
											name="vehicleProfile"
											class="pr-6 pl-6 md:w-1/2 sm:w-1/1"
											:clearable="false"
											:reduce="(option) => option.id"
											:get-option-label="getOptionLabel"
											:options="vehicleProfileList"
											:disabled="
												!dataOptimization.selectedRouter ||
												dataOptimization.profileOption === 'specific'
											"
										>
											<template v-slot:no-options="{search, searching}">
												<template v-if="searching">
													{{ $t("NoResultsFoundFor") + " " }}<em>{{ search }}</em>
												</template>
												<template v-else>
													{{ $t("NoResultsFound") }}
												</template>
											</template>
											<template #option="option">
												<div class="option-with-icon">
													<vs-icon
														class="mr-2"
														style="font-size: 1.5rem"
														:icon="option.icon"
													></vs-icon>
													{{ option.name }}
												</div>
											</template>
										</v-select>
									</div>
								</div>
							</li>
							<li class="mt-4">
								<vs-radio v-model="dataOptimization.profileOption" vs-value="specific">{{
									$t("Optimization.TheProfileOfEachSelectedVehicle")
								}}</vs-radio>
								<p style="text-align: justify; font-size: 12px; color: gray" class="pr-6 pl-6">
									{{ $t("Optimization.OptimizationProfileVehicleText") }}
								</p>
							</li>
						</ul>
					</div>
				</div>
			</vx-card>
		</vue-perfect-scrollbar>
		<vs-popup
			class="vs-con-loading__container"
			style="z-index: 56000"
			:title="$t('ViewMeshesAndTheirStatus')"
			:active.sync="showMeshes"
		>
			<vs-table
				v-if="meshesOpenroutesList.length"
				ref="table"
				:max-items="7"
				:data="meshesOpenroutesList"
				pagination
			>
				<template slot="thead">
					<vs-th sort-key="name">{{ $t("Name") }}</vs-th>
					<vs-th sort-key="description">{{ $t("Description") }}</vs-th>
					<vs-th sort-key="status">{{ $t("State") }}</vs-th>
				</template>
				<template slot-scope="{data}">
					<tbody>
						<vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
							<vs-td>
								<p class="product-name font-medium truncate">{{ tr.label }}</p>
							</vs-td>
							<vs-td>
								<p class="product-category">
									{{ `${tr.label === "South America" ? $t("RoadNetworkWithSouthAmerican") : ""}` }}
								</p>
							</vs-td>
							<vs-td>
								<div class="flex items-center">
									<div
										class="h-3 w-3 rounded-full mr-1"
										:class="{
											'bg-success': tr.status === 'ready',
											'bg-warning': tr.status === 'not ready',
											'bg-danger': tr.status === 'unavailable',
										}"
									></div>
									<span style="font-size: 12px; font-weight: 600">{{
										`${
											tr.status === "ready"
												? $t("Available")
												: tr.status === "not ready"
												? $t("Pending")
												: $t("NotAvailable")
										}`
									}}</span>
								</div>
							</vs-td>
						</vs-tr>
					</tbody>
				</template>
			</vs-table>
			<div class="flex flex-wrap items-center justify-end">
				<vs-button class="mt-base mr-4" icon-pack="feather" icon="icon-download" @click.prevent="exportToExcel"
					>{{ $t("Export") }}
				</vs-button>
			</div>
		</vs-popup>
		<!-- Advanced Objectives Popup -->
		<vs-popup
			class="vs-con-loading__container popup-advanced-objectives"
			style="z-index: 56000"
			:title="$t('AdvancedObjectives.ConfigureAdvancedObjectives')"
			:active.sync="showAdvancedObjectivesPopup"
		>
			<div class="advanced-objectives-popup">
				<!-- Header with Add Button -->
				<div
					class="flex items-center mb-6"
					:class="{
						'justify-between': advancedObjectives.length > 0,
						'justify-end': advancedObjectives.length === 0,
					}"
				>
					<div v-if="advancedObjectives.length > 0" class="flex items-center">
						<h5 class="mb-0 mr-3">{{ $t("AdvancedObjectives.AdvancedObjectives") }}</h5>
						<vs-chip class="font-bold" color="primary"> {{ advancedObjectives.length }} / 8 </vs-chip>
					</div>
					<vs-button
						size="small"
						color="primary"
						icon="add"
						class="font-bold"
						@click="addAdvancedObjective"
						:disabled="advancedObjectives.length >= 8"
					>
						{{ $t("AdvancedObjectives.AddObjective") }}
					</vs-button>
				</div>
				<!-- Objectives Container -->
				<div class="advanced-objectives-container">
					<div v-for="(item, index) in advancedObjectives" :key="index" class="objective-item">
						<div class="objective-header">
							<div class="flex items-center justify-between w-full">
								<h6 class="mb-0 font-bold">{{ $t("AdvancedObjectives.Objective") }} {{ index + 1 }}</h6>
								<div class="flex items-center">
									<feather-icon
										icon="Trash2Icon"
										svgClasses="h-5 w-5 text-danger cursor-pointer font-bold"
										:title="$t('Crud.Delete')"
										@click="removeAdvancedObjective(index)"
									/>
								</div>
							</div>
						</div>
						<div class="objective-content">
							<div class="vx-row">
								<div class="vx-col w-full">
									<small class="date-label">{{ $t("AdvancedObjectives.ObjectiveType") }}</small>
									<v-select
										v-model="item.type"
										append-to-body
										:options="getAvailableObjectiveTypes(index)"
										:reduce="(option) => option.value"
										:get-option-label="(option) => option.label"
										:placeholder="$t('AdvancedObjectives.SelectObjectiveType')"
										@input="onObjectiveTypeChange(index)"
									>
										<template #option="option">
											<div class="objective-option">
												<div class="objective-option-header">
													<span class="objective-name">{{ option.label }}</span>
												</div>
												<div class="objective-description">
													{{ option.description }}
												</div>
											</div>
										</template>
									</v-select>
								</div>
							</div>
							<div class="vx-row">
								<!-- Dynamic Properties Section -->
								<div
									v-if="item.type && getObjectiveProperties(item.type).length > 0"
									class="vx-col w-full"
								>
									<div
										class="properties-container number-property-header"
										:class="{
											'flex flex-wrap items-center gap-2':
												item.type === 'visually_appealing_tours',
										}"
									>
										<div
											v-for="prop in getObjectiveProperties(item.type)"
											:key="prop.key"
											class="property-item"
										>
											<div
												v-if="prop.type === 'number' || prop.type === 'boolean'"
												:class="{'flex items-center justify-between': prop.type === 'boolean'}"
											>
												<label class="flex items-center cursor-pointer font-bold">
													{{ prop.label }}
													<i
														class="material-icons text-primary ml-1"
														style="font-size: 16px"
														:title="prop.description"
													>
														info
													</i>
												</label>
												<!-- Boolean Property -->
												<vs-switch
													v-if="prop.type === 'boolean'"
													v-model="item.properties[prop.key]"
													color="success"
													class="mt-1"
												/>
												<!-- Number Property -->
												<vs-input
													v-else-if="prop.type === 'number'"
													v-model="item.properties[prop.key]"
													type="number"
													:min="prop.min"
													:max="prop.max"
													:step="prop.step || 0.1"
													class="mt-1"
													@input="
														validateNumericInput(
															index,
															prop.key,
															prop.min,
															prop.max,
															$event
														)
													"
													@blur="enforceNumericLimits(index, prop.key, prop.min, prop.max)"
												/>
											</div>
											<!-- Object Property (like eager_delivery) -->
											<div v-else-if="prop.type === 'object'" class="object-property mt-1">
												<div class="vx-row">
													<div class="vx-col w-full flex items-center justify-between">
														<label class="flex items-center cursor-pointer font-bold">
															{{ $t("AdvancedObjectives.EnableEagerDelivery") }}
															<i
																class="material-icons text-primary ml-1"
																style="font-size: 16px"
																:title="prop.description"
															>
																info
															</i>
														</label>
														<vs-switch
															color="success"
															class="mr-2"
															:value="item.properties[prop.key].enabled"
															@input="
																onObjectPropertyChange(
																	index,
																	prop.key,
																	'enabled',
																	$event
																)
															"
														/>
													</div>
												</div>
												<div class="vx-row">
													<div class="vx-col w-full md:w-1/2">
														<label>{{ $t("AdvancedObjectives.TieThreshold") }}</label>
														<vs-input
															type="number"
															:value="item.properties[prop.key].tie_threshold"
															:placeholder="$t('AdvancedObjectives.TieThreshold')"
															:min="0"
															:max="1"
															:step="0.1"
															@input="
																onObjectPropertyChange(
																	index,
																	prop.key,
																	'tie_threshold',
																	$event
																)
															"
															@blur="
																enforceObjectPropertyLimits(
																	index,
																	prop.key,
																	'tie_threshold',
																	0,
																	1000000
																)
															"
														/>
													</div>
													<div class="vx-col w-full md:w-1/2">
														<label>{{
															$t("AdvancedObjectives.ImprovementThreshold")
														}}</label>
														<vs-input
															type="number"
															:value="item.properties[prop.key].improvement_threshold"
															:placeholder="$t('AdvancedObjectives.ImprovementThreshold')"
															:min="0"
															:max="1"
															:step="0.1"
															@input="
																onObjectPropertyChange(
																	index,
																	prop.key,
																	'improvement_threshold',
																	$event
																)
															"
															@blur="
																enforceObjectPropertyLimits(
																	index,
																	prop.key,
																	'improvement_threshold',
																	0,
																	1000000
																)
															"
														/>
													</div>
												</div>
											</div>

											<!-- String Property -->
											<vs-input v-else v-model="item.properties[prop.key]" class="mt-1" />
										</div>
									</div>
								</div>
							</div>

							<!-- Tie Break Configuration -->
							<div v-if="item.type === 'tie_break'" class="vx-row mt-3 number-property-header">
								<div class="vx-col w-full">
									<label class="font-bold">{{ $t("AdvancedObjectives.TieBreakRules") }}</label>
									<div class="tie-break-container">
										<div
											v-for="(rule, ruleIndex) in item.tieBreakRules"
											:key="ruleIndex"
											class="mb-2 mt-2"
										>
											<div class="vx-row">
												<div class="vx-col w-full md:w-2/5">
													<v-select
														v-model="rule.objective"
														:options="getAvailableTieBreakObjectives(index)"
														:placeholder="$t('AdvancedObjectives.SelectObjective')"
													/>
												</div>
												<div class="vx-col w-full md:w-1/4">
													<vs-input
														v-model="rule.tie_threshold"
														type="number"
														:min="0"
														:max="1"
														:step="0.1"
														:placeholder="$t('AdvancedObjectives.TieThreshold')"
														@input="
															validateTieBreakInput(
																index,
																ruleIndex,
																'tie_threshold',
																0,
																1,
																$event
															)
														"
														@blur="
															enforceTieBreakLimits(
																index,
																ruleIndex,
																'tie_threshold',
																0,
																1
															)
														"
													/>
												</div>
												<div class="vx-col w-full md:w-1/4">
													<vs-input
														v-model="rule.improvement_threshold"
														type="number"
														:min="0"
														:max="1"
														:step="0.1"
														:placeholder="$t('AdvancedObjectives.ImprovementThreshold')"
														@input="
															validateTieBreakInput(
																index,
																ruleIndex,
																'improvement_threshold',
																0,
																1,
																$event
															)
														"
														@blur="
															enforceTieBreakLimits(
																index,
																ruleIndex,
																'improvement_threshold',
																0,
																1
															)
														"
													/>
												</div>
												<div class="vx-col w-full md:w-1/12">
													<feather-icon
														icon="TrashIcon"
														svgClasses="mt-2 h-5 w-5 text-danger cursor-pointer font-bold"
														:title="$t('Crud.Delete')"
														@click="removeTieBreakRule(index, ruleIndex)"
													/>
												</div>
											</div>
										</div>
										<vs-button
											size="small"
											color="primary"
											icon="add"
											class="float-right mt-2"
											@click="addTieBreakRule(index)"
										>
											{{ $t("AddRule") }}
										</vs-button>
									</div>
								</div>
							</div>
						</div>
					</div>
					<!-- Empty State -->
					<div v-if="advancedObjectives.length === 0" class="empty-state">
						<div class="empty-state-content">
							<i class="material-icons empty-state-icon">tune</i>
							<h6>{{ $t("AdvancedObjectives.NoAdvancedObjectives") }}</h6>
							<p>{{ $t("AdvancedObjectives.AddAdvancedObjectivesDescription") }}</p>
						</div>
					</div>
				</div>
				<!-- Footer Actions -->
				<div class="flex flex-wrap items-center justify-end mt-6">
					<vs-button color="danger" @click="showAdvancedObjectivesPopup = false" class="mr-2">
						{{ $t("Cancel") }}
					</vs-button>
					<vs-button
						color="primary"
						:disabled="advancedObjectives.length === 0"
						@click="saveAdvancedObjectives"
					>
						{{ $t("Save") }}
					</vs-button>
				</div>
			</div>
		</vs-popup>
	</form>
</template>

<script>
import "flatpickr/dist/flatpickr.css";
import moduleOptimizationGroup from "@/store/optimization-group/moduleOptimizationGroup.js";
import moduleOptimization from "@/store/optimization/moduleOptimization.js";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import {en, es} from "vuejs-datepicker/src/locale";
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import Datepicker from "vuejs-datepicker";
import {Validator} from "vee-validate";

export default {
	name: "OptimizationCreate",
	props: {
		optimizationObject: {
			type: Object,
			default: () => ({
				nameOptimization: "",
				mesh: {},
				group: null,
				selectedRouter: null,
				selectedVehicleProfile: null,
				liveTraffic: true,
				profileOption: "general",
				objectiveListSelected: null,
				period: {
					init_date: new Date(),
					end_date: new Date(),
					init_hour: "00:00:00",
					end_hour: "23:59:59",
				},
			}),
		},
		isReoptimize: {
			type: Boolean,
			default: false,
		},
	},
	components: {
		vSelect,
		flatPickr,
		Datepicker,
		VuePerfectScrollbar,
	},
	data() {
		return {
			langHe: es,
			langEn: en,
			groupOptimizationList: [],
			meshesOpenroutesList: [],
			equivalent_fields_default_selected: [],
			equivalentFields: {},
			showMeshes: false,
			selectedFormat: "xlsx",
			headerTitle: [this.$t("Name"), this.$t("Description"), this.$t("State")],
			headerVal: ["label", "description", "status"],
			objectives: [
				{
					label: this.$t("MinimizeUnassigned"),
					value: "minimize_unassigned",
					disabled: false,
				},
				{
					label: this.$t("MinimizeCost"),
					value: "minimize_cost",
					disabled: false,
				},
				{
					label: this.$t("MinimizeDistance"),
					value: "minimize_distance",
					disabled: false,
				},
				{
					label: this.$t("MinimizeDuration"),
					value: "minimize_duration",
					disabled: false,
				},
				{
					label: this.$t("MinimizeTourCount"),
					value: "minimize_tour_count",
					disabled: false,
				},
				{
					label: this.$t("MaximizeTourCount"),
					value: "maximize_tour_count",
					disabled: false,
				},
				{
					label: this.$t("MinimizeTravelDuration"),
					value: "minimize_travel_duration",
					disabled: false,
				},
			],
			settingsForm: {
				maxScrollbarLength: 60,
				wheelSpeed: 0.6,
			},
			configdateTimePicker: {
				enableSeconds: true,
				enableTime: true,
				noCalendar: true,
			},
			routingTypes: [
				{
					name: "OPENROUTE",
					icon: require("@/assets/images/logo/openroute.png"),
				},
				{
					name: "GMPRO",
					icon: require("@/assets/images/logo/fleetroutingLogo.png"),
				},
				{
					name: "TOUR_PLANNING",
					icon: require("@/assets/images/logo/tour_planning.svg"),
				},
			],
			advancedObjectives: [],
			advancedObjectiveTypes: [
				{
					label: this.$t("MinimizeUnassigned"),
					value: "minimize_unassigned",
					category: "objective",
					description: this.$t("AdvancedObjectives.MinimizeUnassignedDescription"),
				},
				{
					label: this.$t("MinimizeCost"),
					value: "minimize_cost",
					category: "objective",
					description: this.$t("AdvancedObjectives.MinimizeCostDescription"),
				},
				{
					label: this.$t("AdvancedObjectives.MinimizeTours"),
					value: "minimize_tours",
					category: "objective",
					description: this.$t("AdvancedObjectives.MinimizeToursDescription"),
				},
				{
					label: this.$t("AdvancedObjectives.MaximizeTours"),
					value: "maximize_tours",
					category: "objective",
					description: this.$t("AdvancedObjectives.MaximizeToursDescription"),
				},
				{
					label: this.$t("AdvancedObjectives.OptimizeTaskOrder"),
					value: "optimize_task_order",
					category: "objective",
					description: this.$t("AdvancedObjectives.OptimizeTaskOrderDescription"),
				},
				{
					label: this.$t("AdvancedObjectives.MinimizeDistance"),
					value: "minimize_distance",
					category: "objective",
					description: this.$t("AdvancedObjectives.MinimizeDistanceDescription"),
				},
				{
					label: this.$t("AdvancedObjectives.MinimizeDuration"),
					value: "minimize_duration",
					category: "objective",
					description: this.$t("AdvancedObjectives.MinimizeDurationDescription"),
				},
				{
					label: this.$t("AdvancedObjectives.BalanceMaxLoad"),
					value: "balance_max_load",
					category: "balance",
					description: this.$t("AdvancedObjectives.BalanceMaxLoadDescription"),
				},
				{
					label: this.$t("AdvancedObjectives.BalanceActivities"),
					value: "balance_activities",
					category: "balance",
					description: this.$t("AdvancedObjectives.BalanceActivitiesDescription"),
				},
				{
					label: this.$t("AdvancedObjectives.BalanceDistance"),
					value: "balance_distance",
					category: "balance",
					description: this.$t("AdvancedObjectives.BalanceDistanceDescription"),
				},
				{
					label: this.$t("AdvancedObjectives.BalanceDuration"),
					value: "balance_duration",
					category: "balance",
					description: this.$t("AdvancedObjectives.BalanceDurationDescription"),
				},
				{
					label: this.$t("AdvancedObjectives.MaximizePriorityJobs"),
					value: "maximize_priority_jobs",
					category: "priority",
					description: this.$t("AdvancedObjectives.MaximizePriorityJobsDescription"),
				},
				{
					label: this.$t("AdvancedObjectives.MaximizeTerritoryJobs"),
					value: "maximize_territory_jobs",
					category: "territory",
					description: this.$t("AdvancedObjectives.MaximizeTerritoryJobsDescription"),
				},
				{
					label: this.$t("AdvancedObjectives.TourOrder"),
					value: "tour_order",
					category: "optimization",
					description: this.$t("AdvancedObjectives.TourOrderDescription"),
				},
				{
					label: this.$t("AdvancedObjectives.OptimizeTaskPosition"),
					value: "optimize_task_position",
					category: "optimization",
					description: this.$t("AdvancedObjectives.OptimizeTaskPositionDescription"),
				},
				{
					label: this.$t("AdvancedObjectives.VisuallyAppealingTours"),
					value: "visually_appealing_tours",
					category: "visual",
					description: this.$t("AdvancedObjectives.VisuallyAppealingToursDescription"),
				},
				{
					label: this.$t("AdvancedObjectives.MinimizeTourOverlap"),
					value: "minimize_tour_overlap",
					category: "optimization",
					description: this.$t("AdvancedObjectives.MinimizeTourOverlapDescription"),
				},
				{
					label: this.$t("AdvancedObjectives.ServeInClusters"),
					value: "serve_in_clusters",
					category: "clustering",
					description: this.$t("AdvancedObjectives.ServeInClustersDescription"),
				},
				/*{
					label: this.$t("AdvancedObjectives.TieBreak"),
					value: "tie_break",
					category: "tie_break",
					description: this.$t("AdvancedObjectives.TieBreakDescription"),
				}, */
			],
			objectiveTypeSelection: "basic", // 'basic' or 'advanced'
			showAdvancedObjectivesPopup: false,
		};
	},
	watch: {
		async "dataOptimization.selectedRouter"(val) {
			this.$store.commit("SET_ROUTING_TYPE", val);
			await this.$store.dispatch("moduleRoutingType/saveRouting", val);
			const vehicleTypesGMPRO = ["truck", "scooter", "bus", "bicycle"];
			const vehicleTypesOPENROUTE = ["truck", "scooter", "bus", "unknown"];
			if (
				(val === "GMPRO" && vehicleTypesGMPRO.includes(this.selectedTypeVehicle)) ||
				(val === "OPENROUTE" && vehicleTypesOPENROUTE.includes(this.selectedTypeVehicle)) ||
				(val === "TOUR_PLANNING" && this.selectedTypeVehicle === "unknown")
			) {
				this.dataOptimization.selectedVehicleProfile = "car";
				this.$store.commit("moduleRoutingType/SET_TYPE_VEHICLE", "car");
				await this.$store.dispatch("moduleRoutingType/saveTypeVehicle", "car");
			}
		},
		async "dataOptimization.selectedVehicleProfile"(val) {
			this.$store.commit("moduleRoutingType/SET_TYPE_VEHICLE", val);
			await this.$store.dispatch("moduleRoutingType/saveTypeVehicle", val);
		},
		advancedObjectives: {
			handler(newVal) {
				// Validate minimum and maximum objectives
				if (newVal.length < 1) {
					this.$vs.notify({
						title: this.$t("AdvancedObjectives.ValidationError"),
						text: this.$t("AdvancedObjectives.AtLeastOneAdvancedObjectiveRequired"),
						color: "danger",
						time: 5000,
					});
				}
				// Update the parent component with advanced objectives data
				if (this.selectedRoutingType === "TOUR_PLANNING") {
					this.dataOptimization.advanced_objectives = this.getFormattedAdvancedObjectives();
				}
			},
			deep: true,
		},
		objectiveTypeSelection(newVal) {
			if (newVal === "basic") {
				// Switched to basic, clear advanced objectives
				this.advancedObjectives = [];
				this.dataOptimization.advanced_objectives = [];
			} else {
				// Switched to advanced, clear basic objectives
				this.dataOptimization.objectiveListSelected = [];
			}
		},
	},
	computed: {
		groupOptions() {
			return this.groupOptimizationList.map((el) => {
				return {value: el.id, label: el.name};
			});
		},
		meshOptions() {
			return this.meshesOpenroutesList
				.filter((el) => el.status === "ready")
				.map((el) => ({
					value: el.value,
					label: el.label,
					status: el.status,
					nameStatus: this.$t("Available"),
				}));
		},
		selectedRoutingType() {
			return this.$store.state.routingType;
		},
		dataOptimization: {
			get() {
				return this.optimizationObject;
			},
			set(value) {
				this.$emit("OptimizationFields", value);
			},
		},
		standardInput() {
			return this.$store.state.moduleOptimization.standardInputList;
		},
		vehicleProfileList() {
			let profileList = [
				{id: "car", icon: "local_taxi", name: this.$t("Routing.Car")},
				{id: "walk", icon: "directions_walk", name: this.$t("Routing.Walking")},
				{id: "bicycle", icon: "directions_bike", name: this.$t("Routing.Bicycle")},
				{id: "motorcycle", icon: "two_wheeler", name: this.$t("Routing.Motorcycle")},
				{id: "truck", icon: "local_shipping", name: this.$t("Routing.Truck")},
				{id: "scooter", icon: "rv_hookup", name: this.$t("Routing.Scooter")},
				{id: "bus", icon: "directions_bus", name: this.$t("Routing.Bus")},
			];
			switch (this.selectedRoutingType) {
				case "GMPRO":
					profileList.push({id: "unknown", icon: "bus_alert", name: this.$t("NotSpecified")});
					return profileList.filter(
						(profile) =>
							profile.id != "bicycle" &&
							profile.id != "truck" &&
							profile.id != "scooter" &&
							profile.id != "bus"
					);
				case "OPENROUTE":
					return profileList.filter(
						(profile) => profile.id != "truck" && profile.id != "scooter" && profile.id != "bus"
					);
				default:
					return profileList;
			}
		},
		equivalentFieldsDefault: {
			get() {
				let filteredObjectives = this.objectives;

				// Filtrar según el tipo de ruteador seleccionado
				if (this.selectedRoutingType === "GMPRO") {
					// Para GMPRO solo mostrar: minimize_distance, minimize_duration, minimize_tour_count, minimize_travel_duration
					const allowedGMPROValues = [
						"minimize_distance",
						"minimize_duration",
						"minimize_tour_count",
						"minimize_travel_duration",
					];
					filteredObjectives = this.objectives.filter((obj) => allowedGMPROValues.includes(obj.value));
				} else if (this.selectedRoutingType === "TOUR_PLANNING") {
					// Para TOUR_PLANNING mostrar todos menos minimize_travel_duration
					filteredObjectives = this.objectives.filter((obj) => obj.value !== "minimize_travel_duration");
				}
				// Para OPENROUTE mostrar todos (no filtrar)

				return filteredObjectives.filter(
					(e) => !this.equivalent_fields_default_selected.some((eq) => eq === e.value)
				);
			},
			set(val) {},
		},
		availableAdvancedObjectiveTypes() {
			// Obtener los tipos ya seleccionados
			const selectedTypes = this.advancedObjectives.filter((obj) => obj.type !== null).map((obj) => obj.type);

			// Filtrar la lista completa excluyendo los ya seleccionados
			return this.advancedObjectiveTypes.filter((type) => !selectedTypes.includes(type.value));
		},
	},
	created() {
		if (!moduleOptimizationGroup.isRegistered) {
			this.$store.registerModule("moduleOptimizationGroup", moduleOptimizationGroup);
			moduleOptimizationGroup.isRegistered = true;
		}
		if (!moduleOptimization.isRegistered) {
			this.$store.registerModule("moduleOptimization", moduleOptimization);
			moduleOptimization.isRegistered = true;
		}
		Validator.extend("validatorEndHourOptimization", this.validatorEndHourOptimization);
		Validator.extend("validatorInitHourOptimization", this.validatorInitHourOptimization);
		Validator.extend("validatorInitDateOptimization", this.validatorInitDateOptimization);
		Validator.extend("validatorEndDateOptimization", this.validatorEndDateOptimization);
		this.getGroupsOptimizations();
		this.getOpenrouteMesh();
	},
	mounted() {
		if (this.isReoptimize) {
			const groupSelected = this.groupOptions.find(
				(group) => group.value === this.standardInput.optimization_group_id
			);
			const meshSelected = this.meshOptions.find((mesh) => mesh.value === this.standardInput.global_config.mesh);
			if (meshSelected) this.dataOptimization.mesh = {label: meshSelected.label, value: meshSelected.value};
			if (groupSelected) this.dataOptimization.group = {label: groupSelected.label, value: groupSelected.value};
			// Cargar objetivos avanzados si existen
			if (
				this.standardInput.global_config.advanced_objectives &&
				this.standardInput.global_config.advanced_objectives.length > 0
			) {
				this.objectiveTypeSelection = "advanced";
				this.advancedObjectives = this.standardInput.global_config.advanced_objectives.map((obj) => {
					const mapped = {
						type: obj.type,
						properties: {},
						tieBreakRules: [],
					};
					const balanceTypes = [
						"balance_max_load",
						"balance_activities",
						"balance_distance",
						"balance_duration",
					];

					if (balanceTypes.includes(obj.type)) {
						// Para tipos balance, las propiedades están en 'options'
						mapped.properties = {...(obj.options || {})};
					} else {
						if (obj.hasOwnProperty("type") && Object.entries(obj).length > 1) {
							const {type, ...properties} = obj;
							mapped.properties = {...properties};
						} else {
							// Si no hay propiedades adicionales, asegurar que properties quede como objeto vacío
							mapped.properties = {};
						}
					}
					return mapped;
				});
				this.dataOptimization.advanced_objectives = this.getFormattedAdvancedObjectives();
			} else if (
				this.standardInput.global_config.objectives &&
				this.standardInput.global_config.objectives.length > 0
			) {
				this.objectiveTypeSelection = "basic";
			}
		}
	},
	methods: {
		handleAdvancedSelection() {
			this.objectiveTypeSelection = "advanced";
			this.showAdvancedObjectivesPopup = true;
		},
		async getGroupsOptimizations() {
			await this.$store.dispatch("moduleOptimizationGroup/findAll").then((res) => {
				this.groupOptimizationList = res["data"];
				return res;
			});
		},
		async getOpenrouteMesh() {
			await this.$store.dispatch("moduleOptimization/getMeshesOpenroutes").then((res) => {
				this.dataOptimization.mesh =
					res.data.length > 0
						? {label: res["data"][0].label, value: res["data"][0].value, status: res["data"][0].status}
						: {};
				this.meshesOpenroutesList = res["data"];
				return res;
			});
		},
		removeError(errorName) {
			const index = this.errors.items.findIndex((e) => e.field === errorName);
			this.errors.items.splice(index, 1);
		},
		stringTimeToDate(stringTime) {
			let newDate = new Date();
			if (typeof stringTime === "string") {
				const [hours, minutes, seconds] = stringTime.split(":");
				newDate = new Date(1995, 11, 17, parseInt(hours), parseInt(minutes), parseInt(seconds));
			}
			return newDate;
		},
		validatorInitDateOptimization(value, args) {
			this.removeError("initDateOptimization");
			this.removeError("endDateOptimization");
			if (!value || value === "" || typeof value === "number") {
				return true;
			}
			const ih = typeof value === "string" ? new Date(value).getTime() : value.getTime();
			const eh =
				typeof this.dataOptimization.period.end_date === "string"
					? new Date(this.dataOptimization.period.end_date).getTime()
					: this.dataOptimization.period.end_date.getTime();
			return ih <= eh;
		},
		validatorEndDateOptimization(value, args) {
			this.removeError("initDateOptimization");
			this.removeError("endDateOptimization");
			if (!value || value === "" || typeof value === "number") {
				return true;
			}
			const eh = typeof value === "string" ? new Date(value).getTime() : value.getTime();
			const ih =
				typeof this.dataOptimization.period.init_date === "string"
					? new Date(this.dataOptimization.period.init_date).getTime()
					: this.dataOptimization.period.init_date.getTime();
			return eh >= ih;
		},
		validatorEndHourOptimization(value, args) {
			this.removeError("dataHourInitOptimization");
			this.removeError("dataHourEndOptimization");
			const dateInit =
				typeof this.dataOptimization.period.init_date === "string"
					? new Date(this.dataOptimization.period.init_date).getTime()
					: this.dataOptimization.period.init_date.getTime();
			const dateEnd =
				typeof this.dataOptimization.period.end_date === "string"
					? new Date(this.dataOptimization.period.end_date).getTime()
					: this.dataOptimization.period.end_date.getTime();
			if (this.dataOptimization.period.init_hour === "" || value === "" || dateInit != dateEnd) {
				return true;
			}
			return this.stringTimeToDate(value) > this.stringTimeToDate(this.dataOptimization.period.init_hour);
		},
		validatorInitHourOptimization(value, args) {
			this.removeError("dataHourInitOptimization");
			this.removeError("dataHourEndOptimization");
			const dateInit =
				typeof this.dataOptimization.period.init_date === "string"
					? new Date(this.dataOptimization.period.init_date).getTime()
					: this.dataOptimization.period.init_date.getTime();
			const dateEnd =
				typeof this.dataOptimization.period.end_date === "string"
					? new Date(this.dataOptimization.period.end_date).getTime()
					: this.dataOptimization.period.end_date.getTime();
			if (this.dataOptimization.period.end_hour === "" || value === "" || dateInit != dateEnd) {
				return true;
			}
			return this.stringTimeToDate(value) < this.stringTimeToDate(this.dataOptimization.period.end_hour);
		},
		getOptionLabel(option) {
			return option.name;
		},
		setSelected(val) {
			if (Array.isArray(val)) {
				// Validación: Solo uno de maximize_tour_count o minimize_tour_count puede estar seleccionado
				const hasMaximize = val.some((item) =>
					typeof item === "string"
						? item === "maximize_tour_count"
						: Object.values(item).some((value) => value === "maximize_tour_count")
				);
				const hasMinimize = val.some((item) =>
					typeof item === "string"
						? item === "minimize_tour_count"
						: Object.values(item).some((value) => value === "minimize_tour_count")
				);

				if (hasMaximize && hasMinimize) {
					// Si ambos están seleccionados, remover el último seleccionado
					const lastSelected = val[val.length - 1];
					const isLastMaximize =
						typeof lastSelected === "string"
							? lastSelected === "maximize_tour_count"
							: Object.values(lastSelected).some((value) => value === "maximize_tour_count");
					const isLastMinimize =
						typeof lastSelected === "string"
							? lastSelected === "minimize_tour_count"
							: Object.values(lastSelected).some((value) => value === "minimize_tour_count");

					if (isLastMaximize) {
						// Remover maximize_tour_count y mantener minimize_tour_count
						this.dataOptimization.objectiveListSelected = val.filter((item) => {
							if (typeof item === "string") {
								return item !== "maximize_tour_count";
							}
							return !Object.values(item).some((value) => value === "maximize_tour_count");
						});
					} else if (isLastMinimize) {
						// Remover minimize_tour_count y mantener maximize_tour_count
						this.dataOptimization.objectiveListSelected = val.filter((item) => {
							if (typeof item === "string") {
								return item !== "minimize_tour_count";
							}
							return !Object.values(item).some((value) => value === "minimize_tour_count");
						});
					}
					this.$vs.notify({
						title: this.$t("Information"),
						text: this.$t("Optimization.OnlyMaximizeOrMinimizeTourCountAllowed"),
						time: 7000,
					});
					return;
				}

				this.equivalentFields = {};
				this.dataOptimization.objectiveListSelected.find((item, index) => {
					const [label, value] = Object.keys(item);
					const [label_result, value_result] = Object.values(item);
					const valueIndex = index + 1;
					this.equivalentFields[label + valueIndex] = label_result;
					this.equivalentFields[value + valueIndex] = value_result;
				});
				this.equivalent_fields_default_selected = Object.values(this.equivalentFields);
			}
		},
		exportToExcel() {
			import("@/vendor/Export2Excel").then((excel) => {
				const selectedRows = this.meshesOpenroutesList.map((e, index) => {
					return {
						row: index + 1,
						label: e.label,
						description: e.description,
						status: e.status,
					};
				});
				const list = selectedRows;
				const data = this.formatJson(this.headerVal, list);
				excel.export_json_to_excel({
					header: this.headerTitle,
					data,
					filename: this.$t("ViewMeshesAndTheirStatus"),
					autoWidth: true,
					bookType: this.selectedFormat,
				});
			});
		},
		formatJson(filterVal, jsonData) {
			return jsonData.map((v) =>
				filterVal.map((j) => {
					return v[j];
				})
			);
		},
		addAdvancedObjective() {
			this.advancedObjectives.push({
				type: null,
				properties: {},
				tieBreakRules: [],
			});
		},
		removeAdvancedObjective(index) {
			this.advancedObjectives.splice(index, 1);
		},
		onObjectiveTypeChange(index) {
			const objective = this.advancedObjectives[index];
			objective.properties = {};
			objective.tieBreakRules = [];

			// Initialize properties based on type
			const properties = this.getObjectiveProperties(objective.type);
			properties.forEach((prop) => {
				if (prop.type === "boolean") {
					this.$set(objective.properties, prop.key, false);
				} else if (prop.type === "number") {
					this.$set(objective.properties, prop.key, prop.min || 0);
				} else if (prop.type === "object") {
					// Initialize eager_delivery object with proper reactivity
					this.$set(objective.properties, prop.key, {
						enabled: false,
						tie_threshold: 0.5,
						improvement_threshold: 0.1,
					});
				} else {
					this.$set(objective.properties, prop.key, "");
				}
			});
		},
		onObjectPropertyChange(objectiveIndex, propertyKey, field, value) {
			// Ensure reactivity when changing nested object properties
			const objective = this.advancedObjectives[objectiveIndex];
			if (objective && objective.properties && objective.properties[propertyKey]) {
				this.$set(objective.properties[propertyKey], field, value);
			}
		},
		enforceObjectPropertyLimits(objectiveIndex, propertyKey, field, min, max) {
			const value = parseFloat(this.advancedObjectives[objectiveIndex].properties[propertyKey][field]);
			if (isNaN(value)) {
				this.$set(this.advancedObjectives[objectiveIndex].properties[propertyKey], field, min);
			} else if (value < min) {
				this.$set(this.advancedObjectives[objectiveIndex].properties[propertyKey], field, min);
			} else if (value > max) {
				this.$set(this.advancedObjectives[objectiveIndex].properties[propertyKey], field, max);
			}
		},
		getObjectiveProperties(type) {
			const isConstrainedField = [
				{
					key: "is_constrained",
					label: this.$t("AdvancedObjectives.IsConstrained"),
					type: "boolean",
					description: this.$t("AdvancedObjectives.IsConstrainedDescription"),
				},
			];
			switch (type) {
				case "minimize_cost":
					return [
						{
							key: "eager_delivery",
							label: this.$t("AdvancedObjectives.EagerDelivery"),
							type: "object",
							description: this.$t("AdvancedObjectives.EagerDeliveryDescription"),
						},
					];
				case "balance_max_load":
					return [
						{
							key: "threshold",
							label: this.$t("AdvancedObjectives.Threshold"),
							type: "number",
							min: 0.0,
							max: 1.0,
							step: 0.1,
							description: this.$t("AdvancedObjectives.BalanceThresholdDescription"),
						},
					];
				case "balance_activities":
					return [
						{
							key: "threshold",
							label: this.$t("AdvancedObjectives.Threshold"),
							type: "number",
							min: 0.0,
							max: 1.0,
							step: 0.1,
							description: this.$t("AdvancedObjectives.BalanceThresholdDescription"),
						},
					];
				case "balance_distance":
					return [
						{
							key: "threshold",
							label: this.$t("AdvancedObjectives.Threshold"),
							type: "number",
							min: 0.0,
							max: 1.0,
							step: 0.1,
							description: this.$t("AdvancedObjectives.BalanceThresholdDescription"),
						},
					];
				case "balance_duration":
					return [
						{
							key: "threshold",
							label: this.$t("AdvancedObjectives.Threshold"),
							type: "number",
							min: 0.0,
							max: 1.0,
							step: 0.1,
							description: this.$t("AdvancedObjectives.BalanceThresholdDescription"),
						},
					];
				case "tour_order":
					return isConstrainedField;
				case "optimize_task_position":
					return isConstrainedField;
				case "visually_appealing_tours":
					return [
						{
							key: "weight",
							label: this.$t("AdvancedObjectives.Weight"),
							type: "number",
							min: 0,
							max: 100,
							step: 1,
							description: this.$t("AdvancedObjectives.WeightDescription"),
						},
						{
							key: "tolerance",
							label: this.$t("AdvancedObjectives.Tolerance"),
							type: "number",
							min: 0,
							max: 100,
							step: 1,
							description: this.$t("AdvancedObjectives.ToleranceDescription"),
						},
						{
							key: "max_cluster_radius",
							label: this.$t("AdvancedObjectives.MaxClusterRadius"),
							type: "number",
							min: 10,
							max: 100000,
							step: 1,
							description: this.$t("AdvancedObjectives.MaxClusterRadiusDescription"),
						},
					];
				case "minimize_tour_overlap":
					return [
						{
							key: "tolerance",
							label: this.$t("AdvancedObjectives.Tolerance"),
							type: "number",
							min: 0.0,
							max: 1.0,
							step: 0.1,
							description: this.$t("AdvancedObjectives.ToleranceDescription"),
						},
					];
				case "serve_in_clusters":
					return [
						{
							key: "max_cluster_radius",
							label: this.$t("AdvancedObjectives.MaxClusterRadius"),
							type: "number",
							min: 10,
							max: 100000,
							step: 1,
							description: this.$t("AdvancedObjectives.MaxClusterRadiusDescription"),
						},
					];
				default:
					return [];
			}
		},
		getAvailableTieBreakObjectives(advancedObjectiveIndex) {
			const currentObjective = this.advancedObjectives[advancedObjectiveIndex];
			const availableObjectives = this.advancedObjectiveTypes.filter(
				(type) => type.category === "objective" && type.value !== currentObjective.type
			);
			return availableObjectives.map((type) => ({label: type.label, value: type.value}));
		},
		getAvailableObjectiveTypes(currentIndex) {
			// Obtener todos los tipos ya seleccionados en otros objetivos
			const selectedTypes = this.advancedObjectives
				.map((obj, index) => ({type: obj.type, index}))
				.filter((item) => item.type !== null && item.index !== currentIndex)
				.map((item) => item.type);

			// Filtrar la lista completa excluyendo los ya seleccionados
			// También incluir el tipo actual si está seleccionado
			const currentObjective = this.advancedObjectives[currentIndex];
			const availableTypes = this.advancedObjectiveTypes.filter((type) => {
				// Si es el tipo actual, siempre incluirlo
				if (currentObjective && currentObjective.type === type.value) {
					return true;
				}
				// Si no está seleccionado en otros objetivos, incluirlo
				return !selectedTypes.includes(type.value);
			});

			return availableTypes;
		},
		addTieBreakRule(advancedObjectiveIndex) {
			this.advancedObjectives[advancedObjectiveIndex].tieBreakRules.push({
				objective: null,
				tie_threshold: 0.5,
				improvement_threshold: 0.1,
			});
		},
		removeTieBreakRule(advancedObjectiveIndex, ruleIndex) {
			this.advancedObjectives[advancedObjectiveIndex].tieBreakRules.splice(ruleIndex, 1);
		},
		validateNumericInput(objectiveIndex, propertyKey, min, max, event) {
			if (!event || !event.target) {
				return;
			}
			const value = parseFloat(event.target.value);
			if (isNaN(value) || value < min || value > max) {
				event.target.value = this.advancedObjectives[objectiveIndex].properties[propertyKey];
			}
		},
		enforceNumericLimits(objectiveIndex, propertyKey, min, max) {
			const value = parseFloat(this.advancedObjectives[objectiveIndex].properties[propertyKey]);
			if (isNaN(value)) {
				this.$set(this.advancedObjectives[objectiveIndex].properties, propertyKey, min);
			} else if (value < min) {
				this.$set(this.advancedObjectives[objectiveIndex].properties, propertyKey, min);
			} else if (value > max) {
				this.$set(this.advancedObjectives[objectiveIndex].properties, propertyKey, max);
			}
		},
		validateTieBreakInput(objectiveIndex, ruleIndex, propertyKey, min, max, event) {
			const value = parseFloat(event.target.value);
			if (isNaN(value) || value < min || value > max) {
				event.target.value = this.advancedObjectives[objectiveIndex].tieBreakRules[ruleIndex][propertyKey];
			}
		},
		enforceTieBreakLimits(objectiveIndex, ruleIndex, propertyKey, min, max) {
			const value = parseFloat(this.advancedObjectives[objectiveIndex].tieBreakRules[ruleIndex][propertyKey]);
			if (isNaN(value)) {
				this.$set(this.advancedObjectives[objectiveIndex].tieBreakRules[ruleIndex], propertyKey, min);
			} else if (value < min) {
				this.$set(this.advancedObjectives[objectiveIndex].tieBreakRules[ruleIndex], propertyKey, min);
			} else if (value > max) {
				this.$set(this.advancedObjectives[objectiveIndex].tieBreakRules[ruleIndex], propertyKey, max);
			}
		},
		validateAdvancedObjectives() {
			// Check if at least one objective is required for Tour Planning
			if (this.selectedRoutingType === "TOUR_PLANNING" && this.advancedObjectives.length === 0) {
				this.$vs.notify({
					title: this.$t("AdvancedObjectives.ValidationError"),
					text: this.$t("AdvancedObjectives.AtLeastOneAdvancedObjectiveRequired"),
					color: "danger",
					time: 5000,
				});
				return false;
			}

			// Check if all objectives have a type selected
			const invalidObjectives = this.advancedObjectives.filter((obj) => !obj.type);
			if (invalidObjectives.length > 0) {
				this.$vs.notify({
					title: this.$t("AdvancedObjectives.ValidationError"),
					text: this.$t("AdvancedObjectives.AllObjectivesMustHaveType"),
					color: "danger",
					time: 5000,
				});
				return false;
			}

			// Validate tie break rules
			const tieBreakObjectives = this.advancedObjectives.filter((obj) => obj.type === "tie_break");
			for (const objective of tieBreakObjectives) {
				if (objective.tieBreakRules.length === 0) {
					this.$vs.notify({
						title: this.$t("AdvancedObjectives.ValidationError"),
						text: this.$t("AdvancedObjectives.TieBreakMustHaveRules"),
						color: "danger",
						time: 5000,
					});
					return false;
				}

				for (const rule of objective.tieBreakRules) {
					if (!rule.objective) {
						this.$vs.notify({
							title: this.$t("AdvancedObjectives.ValidationError"),
							text: this.$t("AdvancedObjectives.TieBreakRulesMustHaveObjective"),
							color: "danger",
							time: 5000,
						});
						return false;
					}
				}
			}

			return true;
		},
		getFormattedAdvancedObjectives() {
			return this.advancedObjectives
				.filter((obj) => obj.type !== null)
				.map((obj) => {
					const formatted = {
						type: obj.type,
					};
					const balanceTypes = [
						"balance_max_load",
						"balance_activities",
						"balance_distance",
						"balance_duration",
					];
					if (balanceTypes.includes(obj.type)) {
						formatted.options = {...(obj.properties || {})};
						if (formatted.options) {
							Object.keys(formatted.options).forEach((key) => {
								const value = formatted.options[key];
								// Si es string y se puede convertir a número, parsearlo
								if (typeof value === "string" && !isNaN(parseFloat(value))) {
									formatted.options[key] = parseFloat(value);
								} else if (typeof value === "number") {
									formatted.options[key] = value;
								} else {
									formatted.options[key] = value;
								}
							});
						}
					} else {
						// Para propiedades no balance, también parsear números
						const parsedProperties = {};
						Object.keys(obj.properties || {}).forEach((key) => {
							const value = obj.properties[key];
							// Si es string y se puede convertir a número, parsearlo
							if (typeof value === "string" && !isNaN(parseFloat(value))) {
								parsedProperties[key] = parseFloat(value);
							} else if (typeof value === "number") {
								parsedProperties[key] = value;
							} else if (typeof value === "object" && value !== null) {
								// Para objetos como eager_delivery, parsear sus propiedades numéricas
								const parsedObject = {};
								Object.keys(value).forEach((objKey) => {
									const objValue = value[objKey];
									if (typeof objValue === "string" && !isNaN(parseFloat(objValue))) {
										parsedObject[objKey] = parseFloat(objValue);
									} else {
										parsedObject[objKey] = objValue;
									}
								});
								parsedProperties[key] = parsedObject;
							} else {
								parsedProperties[key] = value;
							}
						});
						Object.assign(formatted, parsedProperties);
					}

					// Add tie break rules if applicable
					if (obj.type === "tie_break" && obj.tieBreakRules.length > 0) {
						formatted.tie_break_rules = obj.tieBreakRules.map((rule) => ({
							objective: rule.objective,
							tie_threshold: parseFloat(rule.tie_threshold) || 0.5,
							improvement_threshold: parseFloat(rule.improvement_threshold) || 0.1,
						}));
					}

					return formatted;
				});
		},
		saveAdvancedObjectives() {
			// Validate before saving
			if (!this.validateAdvancedObjectives()) {
				return;
			}
			// Update the parent component
			this.dataOptimization.advanced_objectives = this.getFormattedAdvancedObjectives();
			// Close popup
			this.showAdvancedObjectivesPopup = false;
			// Show success message
			this.$vs.notify({
				title: this.$t("Success"),
				text: this.$t("AdvancedObjectives.AdvancedObjectivesSaved"),
				color: "success",
				time: 3000,
			});
		},
	},
};
</script>
<style lang="scss" scoped>
.scroll-area--form {
	margin: auto;
	width: 100%;
	min-height: 440px;
	max-height: 610px;
}
.option-with-icon {
	display: flex;
	align-items: center;
}
.option-icon {
	width: 20px;
	height: 20px;
	margin-right: 8px;
}
.advanced-objectives-section {
	padding: 15px;
	border: 1px solid #eee;
	border-radius: 8px;
	background-color: #fafafa;
	transition: all 0.3s ease;

	&:hover {
		background-color: #f5f5f5;
		border-color: #ddd;
	}

	h6 {
		margin-bottom: 0;
		color: #333;
	}

	.vs-badge {
		font-size: 0.8rem;
	}

	p {
		margin-bottom: 0;
		line-height: 1.4;
	}
}
.advanced-objectives-popup {
	.advanced-objectives-container {
		max-height: 60vh;
		overflow-y: auto;
		padding-right: 10px;

		.objective-item {
			border: 1px solid #eee;
			border-radius: 8px;
			padding: 15px;
			margin-bottom: 15px;
			transition: all 0.3s ease;

			&:hover {
				box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
			}

			.objective-header {
				display: flex;
				justify-content: space-between;
				align-items: center;
				margin-bottom: 10px;

				h6 {
					margin-bottom: 0;
				}
			}

			.objective-content {
				.vx-row {
					align-items: flex-start;
					margin-bottom: 15px;

					&:last-child {
						margin-bottom: 0;
					}

					.vx-col {
						padding: 0 10px;
					}
				}
			}

			.properties-container {
				.property-item {
					margin-bottom: 15px;
					.property-label {
						font-size: 0.9rem;
						font-weight: 600;
						color: #333;
						margin-bottom: 5px;
					}

					.vs-input {
						margin-top: 10px;
					}

					.object-property {
						.object-property-header {
							margin-bottom: 10px;
							padding: 20px;
							background-color: #f8f9fa;
							border-radius: 4px;

							span {
								font-weight: 600;
								color: #333;
							}
						}
					}
				}
			}
		}

		.empty-state {
			text-align: center;
			padding: 30px 0;

			.empty-state-content {
				.empty-state-icon {
					font-size: 60px;
					color: #ccc;
					margin-bottom: 15px;
				}

				h6 {
					font-size: 1.2rem;
					color: #555;
					margin-bottom: 10px;
				}

				p {
					font-size: 0.9rem;
					color: #888;
				}
			}
		}
	}
	.number-property-header {
		margin-bottom: 10px;
		padding: 20px;
		background-color: #f8f9fa;
		border-radius: 15px;
		span {
			font-weight: 600;
			color: #333;
		}
	}
}
.objective-option {
	.objective-option-header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 5px;

		.objective-name {
			font-weight: 600;
			color: #333;
		}
	}

	.objective-description {
		font-size: 0.8rem;
		color: #666;
		line-height: 1.3;
	}
}
</style>
<style lang="scss">
.popup-advanced-objectives {
	.vs-popup {
		width: 900px !important;
	}
	.vs-popup--close {
		display: none !important;
	}
}
</style>
